export const serializeOptions = <T extends object>(options: T) => {
  const parts: string[] = [];

  Object.entries(options).forEach(([key, value]) => {
    parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
  });

  return parts.length > 0 ? `?${parts.join('&')}` : '';
};

export const passToBody = <T extends object>(options: T) => {
  const urlencoded = new URLSearchParams();

  Object.entries(options).forEach(([key, value]) => {
    urlencoded.append(key, value);
  });

  return urlencoded;
};

export const passToFormBody = <T extends object>(options: T) => {
  const formData = new FormData();

  Object.entries(options).forEach(([key, value]) => {
    formData.append(key, value);
  });

  return formData;
};

export function isJson(str: string) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}
